import CommonService from "@services/common.service"
import { ICardApplicationTabHelpUI } from "./types"

import { Button, Card, Divider, Flex } from "@ui/index"
import { IconCopy, IconDownload } from "@img/icons"


/** UI - Вкладка информация для оператора */
export const CardApplicationTabHelpUI = ({
    programsList, disciplinesPP, countDisciplineSectionPP, disciplinesPK, countDisciplineSectionPK,
    txtClientName, txtClientPhone, txtClientEmail, txtAttestationType,
    txtDurationEducation, txtProgramTypeID, txtVolumeHours, txtEducationDateStart,
    txtEducationDateEnd, txtProgramSum, 
    downloadFile, handleCopyToClipBoard,
}: ICardApplicationTabHelpUI) => {
    const programPK = programsList.value.filter((fil) => fil.programID === 1)
    const programPP = programsList.value.filter((fil) => fil.programID === 2)

    const pageCanonical = CommonService.normalizeHttpsUrl(programsList.value[0]?.pageCanonical)
    const requirementName = programsList.value[0]?.requirementName || ''
    const qualification = programsList.value[0]?.qualification || ''
    const sphere = programsList.value[0]?.sphere || ''


    /** Вычисляем скидку, при полной оплате */
    const fullPaymentDiscount = (sum: number) => {
        const sumDiscount = (sum * 15) / 100
        const rounded = Math.ceil(sumDiscount / 500) * 500

        const actualDiscountAmount = sum - rounded
        const actualDiscountPercent = (rounded / sum) * 100

        return {
            discountedSum: actualDiscountAmount,
            actualDiscountPercent: parseFloat(actualDiscountPercent.toFixed(2)),
            discountAmount: rounded
        }
    }


    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider prefix={<h4>Ссылка на курс</h4>} />

                <Card>
                    {pageCanonical
                        ? <a href={pageCanonical} target="_blank" rel="noreferrer" className="link_style">{pageCanonical}</a>
                        : '----'}
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Информация о клиенте</h4>} />

                <Card header='Имя' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">{txtClientName.value}</Card>
                <Card header='Телефон' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center"><a href={`tel:${txtClientPhone.value.replaceAll(' ', '')}`} className="link_style">{txtClientPhone.value}</a></Card>
                <Card header='Email' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">{txtClientEmail.value ? <a href={`mailto:${txtClientEmail.value}`} className="link_style">{txtClientEmail.value}</a> : '----'}</Card>
                <Card header='Написать в' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">
                    <a target="_blank" href={`https://wa.me/${txtClientPhone.value.replaceAll(' ', '')}`} rel="noreferrer" className="link_style">WhatsApp</a>
                </Card>
                <Card header='Написать в' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">
                    <a href={`viber://chat?number=${txtClientPhone.value.replace('+', '%2B').replaceAll(' ', '')}`} rel="noreferrer" className="link_style">Viber</a>
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Условия обучения</h4>} />

                <Card header='Обучение' mainPadding="2px">Дистанционное на нашей образовательной платформе в системе Мудл (Moodle)</Card>
                <Card header='Требования к образованию' mainPadding="2px">{requirementName}</Card>
                <Card header='Форма контроля' mainPadding="2px" >Защита выпускной работы</Card>
                <Card header='Тип аттестации' mainPadding="2px">{txtAttestationType.value}</Card>
                <Card header='Длительность' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">
                    {CommonService.formatDuration(Number(txtDurationEducation.value), txtProgramTypeID.value === 2)}
                </Card>
                <Card header='Объём' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">
                    {CommonService.formatHours(Number(txtVolumeHours.value))}
                </Card>
                <Card header='Начало' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">{txtEducationDateStart.value}</Card>
                <Card header='Окончание' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">{txtEducationDateEnd.value}</Card>
                <Card header='Стоимость' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">{txtProgramSum.value} ₽</Card>
                <Card header='Помесячная' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">
                    {Math.round(Number(txtProgramSum.value) / Number(txtDurationEducation.value))} ₽/мес.
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Документы</h4>} />

                <Card header='Преподаватели' mainPadding="2px">Курс подготовлен ведущими преподавателями ВУЗов</Card>
                <Card header='Квалификация' mainPadding="2px">
                    {txtProgramTypeID.value === 1 && `Диплом о профессиональной переподготовке с присвоением квалификации ${qualification}, в сфере ${sphere}`}
                    {txtProgramTypeID.value === 2 && `Удостоверение о повышении квалификации с присвоением квалификации ${qualification}, в сфере ${sphere}`}
                </Card>
                <Card header='Прочее' mainPadding="2px">
                    <Flex gap="6px">
                        <p>Документы установленного образца, с 2013 года с принятием нового закона об образовании в РФ для профессиональной переподготовки и повышения квалификации.</p>
                        <p>Документы установленного образца, поэтому никому не верьте, что диплом о проф. переподготовке будет гос. образца.</p>
                    </Flex>
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Материалы курса</h4>} />

                <Card header='Для куратора' headerWidth="130px" mainPadding="0 0 0 2px" headerPosition="left" headerAlignItems="center">Видео пока нет</Card>
                <Card header='Прочее' mainPadding="2px">
                    Обучение дистанционное, на нашей образовательной платформе, материал представлен в виде лекций и заданий по дисциплинам учебного плана.
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Пакет документов для налогового вычета</h4>} />

                <Card header='Желательно говорить это вместе с информацией об отправке диплома по почте' mainPadding="2px">
                    <Flex gap="6px">
                        <p>Кроме того вы имеете возможность оформить налоговый вычет на наши образовательные Услуги.</p>
                        <p>Наша академия имеет официальную лицензию на осуществление образовательной деятельности.</p>
                        <p>Весь необходимый пакет документов для оформления вычета направляется Вам вместе с дипломом.</p>
                        <p>Максимальная сумма выплат по налоговому вычету на образование составляет 15 600 рублей.</p>
                    </Flex>
                </Card>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>После заключения договора</h4>} />

                <Card header='Информация' mainPadding="2px">
                    <Flex gap="6px">
                        <p>После заключения договора мы предоставляем Вам доступ в личный кабинет.</p>
                        <p>В личном кабинете находится лекционный материал, задания и тесты по дисциплинам.</p>
                        <p>Вы проходите курс и пишите итоговую атестанционную работу по данному курсу (аналог дипломной работы) которая загружается в информационную образовательную среду.</p>
                    </Flex>
                </Card>
            </Flex>


            <Flex gap="5px">
                <Divider prefix={<h4>Доступные программы</h4>} />

                {programPK.length > 0 &&
                    <Card mainPadding="2px"
                        header={
                            <Flex flexDirection="row" alignItems="center" justifyContent="space-between">
                                <div>Профессиональная переподготовка</div>
                                <Button id='tooltipBtnCopyAll' size="xs" variant="iconInput"
                                    onClick={() => handleCopyToClipBoard(`
                                        ${programPK.map((item) => (
                                            `${CommonService.formatHours(Number(item.volumeHours))}; ${item.sum} рублей; ${CommonService.formatDuration(Number(item.durationEducation), false)}; ${item.price} рублей в месяц;`
                                        )).join('\n')}
                                    `)}
                                ><IconCopy /></Button>
                            </Flex>
                        }
                    >
                        <Flex gap="6px">
                            {programPK.map((item) => (
                                <Card key={item.volumeHours}>
                                    <Flex gap="10px">
                                        <Flex flexDirection="row" alignItems="center" justifyContent="space-between">
                                            <div>{CommonService.formatHours(Number(item.volumeHours))}; {item.sum} рублей; {CommonService.formatDuration(Number(item.durationEducation), false)}; {item.price} рублей в месяц;</div>
                                            
                                            <Flex gap="10px" flexDirection="row">
                                                <Button id='tooltipBtnDownload' size="xs" variant="iconInput" onClick={() => downloadFile(`${item.volumeHours}_${item.courseAlias}`, `${item.docPath}`)}><IconDownload /></Button>
                                                <Button id='tooltipBtnCopy' size="xs" variant="iconInput" onClick={() => handleCopyToClipBoard(`${CommonService.formatHours(Number(item.volumeHours))}; ${item.sum} рублей; ${CommonService.formatDuration(Number(item.durationEducation), false)}; ${item.price} рублей в месяц;`)}><IconCopy /></Button>
                                            </Flex>
                                        </Flex>

                                        <div style={{ gap: '4px', display: 'flex', flexDirection: 'column', background: '#e5e5e5', borderRadius: '8px' }}>
                                            <Divider prefix={<h4>Доп. скидка при полной оплате</h4>} />

                                            <div style={{padding: '0px 8px 8px 8px'}}>
                                                При полной оплате курса в течении 10 календарных дней, Вы можете получить дополнительную скидку:<br/>
                                                • <b>{CommonService.formatHours(Number(item.volumeHours))}</b> - полная стоимость <b>{item.sum} рублей ({item.price} рублей в месяц)</b>, дополнительная скидка - <b>{fullPaymentDiscount(Number(item.sum)).discountAmount} рублей ({fullPaymentDiscount(Number(item.sum)).actualDiscountPercent}%)</b>, в итоге стоимость со скидкой за курс составит - <b>{fullPaymentDiscount(Number(item.sum)).discountedSum} рублей</b>.
                                            </div>
                                        </div>
                                    </Flex>
                                </Card>
                            ))}
                        </Flex>
                    </Card>
                }

                {programPP.length > 0 &&
                    <Card mainPadding="2px"
                        header={
                            <Flex flexDirection="row" alignItems="center" justifyContent="space-between">
                                <div>Повышение квалификации</div>
                                <Button id='tooltipBtnCopyAll' size="xs" variant="iconInput"
                                    onClick={() => handleCopyToClipBoard(`
                                        ${programPP.map((item) => (`${CommonService.formatHours(Number(item.volumeHours))}; ${item.sum} рублей; ${CommonService.formatDuration(Number(item.durationEducation), true)}`)).join('\n')}
                                    `)}
                                ><IconCopy /></Button>
                            </Flex>
                        }
                    >
                        <Flex gap="6px">
                            {programPP.map((item) => (
                                <Card key={item.volumeHours}>
                                    <Flex gap="10px">
                                        <Flex flexDirection="row" alignItems="center" justifyContent="space-between">
                                            <div>{CommonService.formatHours(Number(item.volumeHours))}; {item.sum} рублей; {CommonService.formatDuration(Number(item.durationEducation), true)};</div>
                                            
                                            <Flex gap="10px" flexDirection="row">
                                                <Button id='tooltipBtnDownload' size="xs" variant="iconInput" onClick={() => downloadFile(`${item.volumeHours}_${item.courseAlias}`, `${item.docPath}`)}><IconDownload /></Button>
                                                <Button id='tooltipBtnCopy' size="xs" variant="iconInput" onClick={() => handleCopyToClipBoard(`${CommonService.formatHours(Number(item.volumeHours))}; ${item.sum} рублей; ${CommonService.formatDuration(Number(item.durationEducation), true)};`)}><IconCopy /></Button>
                                            </Flex>
                                        </Flex>

                                        <div style={{ gap: '4px', display: 'flex', flexDirection: 'column', background: '#e5e5e5', borderRadius: '8px' }}>
                                            <Divider prefix={<h4>Доп. скидка при полной оплате</h4>} />

                                            <div style={{padding: '0px 8px 8px 8px'}}>
                                                При полной оплате курса в течении 10 календарных дней, Вы можете получить дополнительную скидку:<br/>
                                                • <b>{CommonService.formatHours(Number(item.volumeHours))}</b> - полная стоимость <b>{item.sum} рублей ({item.price} рублей в месяц)</b>, дополнительная скидка - <b>{fullPaymentDiscount(Number(item.sum)).discountAmount} рублей ({fullPaymentDiscount(Number(item.sum)).actualDiscountPercent}%)</b>, в итоге стоимость со скидкой за курс составит - <b>{fullPaymentDiscount(Number(item.sum)).discountedSum} рублей</b>.
                                            </div>
                                        </div>
                                    </Flex>
                                </Card>
                            ))}
                        </Flex>
                    </Card>
                }
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Дисциплины по программам</h4>} />

                {disciplinesPP.value.length > 0 &&
                    <Card mainPadding="2px" header='Профессиональная переподготовка'>
                        {countDisciplineSectionPP.value.map((section, index) => (
                            <Flex key={index} flexDirection="row">
                                <Flex>
                                    {disciplinesPP.value.filter(item => item.volume_hours === section).map((item, index) => (
                                        <div key={index} style={{ marginLeft: '6px' }}>• {item.discipline_name}</div>
                                    ))}

                                    <b>👆 {section} часов</b>
                                </Flex>
                            </Flex>
                        ))}
                    </Card>
                }

                {disciplinesPK.value.length > 0 &&
                    <Card mainPadding="2px" header='Повышение квалификации'>
                        {countDisciplineSectionPK.value.map((section, index) => (
                            <Flex key={index} flexDirection="row">
                                <Flex>
                                    {disciplinesPK.value.filter(item => item.volume_hours === section).map((item, index) => (
                                        <div key={index} style={{ marginLeft: '6px' }}>• {item.discipline_name}</div>
                                    ))}

                                    <b>👆 {section} часов</b>
                                </Flex>
                            </Flex>
                        ))}
                    </Card>
                }
            </Flex>
        </Flex>

        {/* <ToolTip anchorSelect="#tooltipBtnCopyAll" content='Копировать в буфер всё' place="left" />
        <ToolTip anchorSelect="#tooltipBtnCopy" content='Копировать в буфер' place="left" />
        <ToolTip anchorSelect="#tooltipBtnDownload" content='Скачать учебный план' place="left" /> */}
    </>
}